import React, { useEffect, useMemo } from 'react';

interface UseMultipleScrollLockProps {
  refs: Array<React.RefObject<HTMLElement | null>>;
  enabled: boolean;
  includeBody?: boolean;
}

export function useMultiScrollLock({ refs, enabled, includeBody }: UseMultipleScrollLockProps) {
  const elements = useMemo(() => {
    const els = refs.map((ref) => ref.current).filter(Boolean) as HTMLElement[];
    if (includeBody) {
      els.push(document.body);
    }
    return els;
  }, [refs, includeBody]);

  useEffect(() => {
    const prevOverflows = elements.map((el) => el.style.overflow);

    if (enabled) {
      elements.forEach((el) => (el.style.overflow = 'hidden'));
    }

    return () => {
      elements.forEach((el, idx) => {
        el.style.overflow = prevOverflows[idx];
      });
    };
  }, [enabled, elements]);
}
